import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Button, Card, CardContent, FormControl, FormLabel, Input, MenuItem, Paper, Select, Table, TableBody,
    TableCell, TableHead, TablePagination, TableRow, Tooltip
} from '@material-ui/core';
import api from '../../../services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { ANAO, ASIM } from 'consts';
import { formatData } from 'lib/functions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class AbastecimentoList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('abastecimentoSearchFilter')) || {
            nroveiculo: '',
            veiculoproprio: 'T',
            datainicial: '',
            datafinal: ''
        },
        abastecimentos: [],
        totalItems: 0,
        page: Number(sessionStorage.getItem('abastecimentoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('abastecimentoRowsPerPage')) || 10
    };

    estilo = {
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center'
        },
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };

    constructor(props) {
        super(props);
    };

    /* Carregamento inicial */
    async componentDidMount() {
        this.loadAbastecimentos();
    };

    /* Paginação */
    componentDidUpdate(prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('abastecimentoSearchFilter', JSON.stringify(searchFilter));
        }
        if (prevState.page !== page) {
            sessionStorage.setItem('abastecimentoPage', page);
        }
        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('abastecimentoRowsPerPage', rowsPerPage);
        }
    };

    /* Carrega abastecimentos */
    loadAbastecimentos = async () => {
        const { page, rowsPerPage, searchFilter } = this.state;
        const { nroveiculo, veiculoproprio, datainicial, datafinal } = searchFilter;
        
        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (nroveiculo) {
            params += `&NROVEICULO=_like_${nroveiculo}`;
        }

        if (veiculoproprio && veiculoproprio !== 'T') {
            params += `&VEICULOPROPRIO=${veiculoproprio}`;
        }

        if (datainicial) {
            params += `&DATAINICIAL=${datainicial}`;
        }

        if (datafinal) {
            params += `&DATAFINAL=${datafinal}`;
        }

        try {
            const response = await api.get('/abastecimento' + params);
            this.setState({
                abastecimentos: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar abastecimentos:', error);
            this.setState({ abastecimentos: [], totalItems: 0 });
        }
    };

    /* Muda página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.loadAbastecimentos());
    };

    /* Muda quantidade por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => this.loadAbastecimentos());
    };

    /* Escolha de um registro para exclusão */
    handleSelectItem = (id) => {
        this.setState({ selectedId: id });
    };

    /* Deleta abastecimento */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/abastecimento/${id}`);

            if (response.status === 200) {
                this.handleClose();
                this.loadAbastecimentos();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela confirmação para exclusão */
    handleOpen = (codabastecimento) => {
        this.setState({ open: true });
        this.handleSelectItem(codabastecimento);
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisar filtros na tela */
    onChangeSearch = (event) => {
        const { checked, name, type, value } = event.target;
        const searchFilter = { ...this.state.searchFilter };

        if (type === 'checkbox') {
            searchFilter[name] = checked;
        } else if (name === 'datainicial' || name === 'datafinal') {
            searchFilter[name] = value;
        } else {
            searchFilter[name] = (typeof value === 'string') ? value.toUpperCase() : value;
        }

        this.setState({ searchFilter });
    };

    /* Limpa Filtros na tela */
    limpaFiltros = () => {
        const searchFilter = {
            nroveiculo: '',
            veiculoproprio: 'T',
            datainicial: '',
            datafinal: ''
        };

        this.setState({ searchFilter, page: 0 }, () => {
            this.loadAbastecimentos();
        });
    };

    render() {
        const {
            abastecimentos,
            searchFilter,
            open,
            selectedId,
            openAlert,
            messageAlert,
            totalItems,
            page,
            rowsPerPage
        } = this.state;
        const { addButton } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        padding: '10px 20px',
                        width: '100%',
                        gap: 15
                    }}
                >
                    <Input
                        autoFocus
                        id="nroveiculo"
                        name="nroveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Veículo"
                        value={searchFilter.nroveiculo}
                        style={{ width: 200 }}
                    />

                    <Select
                        id="veiculoproprio"
                        name="veiculoproprio"
                        value={searchFilter.veiculoproprio || 'T'}
                        onChange={this.onChangeSearch}
                        style={{
                            width: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Próprios
                        </MenuItem>

                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Terceiros
                        </MenuItem>

                        <MenuItem
                            value="T"
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <FormControl
                        component="fieldset"
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #bdbdbd',
                            borderRadius: 12,
                            justifyContent: 'center'
                        }}
                    >
                        <FormLabel
                            component="legend"
                            style={{
                                fontSize: 12,
                                padding: '0 4px',
                                color: '#616161'
                            }}
                        >
                            Período abastecimento
                        </FormLabel>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                            }}
                        >
                            <Input
                                id="datainicial"
                                name="datainicial"
                                type="date"
                                value={searchFilter.datainicial || ''}
                                onChange={this.onChangeSearch}
                                style={{ width: 120 }}
                            />

                            <span>a</span>

                            <Input
                                id="datafinal"
                                name="datafinal"
                                type="date"
                                value={searchFilter.datafinal || ''}
                                onChange={this.onChangeSearch}
                                style={{ width: 120 }}
                            />
                        </div>
                    </FormControl>

                    <span style={{ display: 'inline-flex', gap: 5 }}>
                        <Tooltip
                            title="Procurar"
                            enterDelay={50}
                        >
                            <SearchIcon
                                onClick={() => this.loadAbastecimentos()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer'
                                }}
                            />
                        </Tooltip>

                        <Tooltip
                            title="Limpar"
                            enterDelay={50}
                        >
                            <BackspaceOutlinedIcon
                                onClick={() => this.limpaFiltros()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer'
                                }}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/abastecimento/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Data</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {abastecimentos.map(abastecimento => (
                                            <TableRow
                                                hover
                                                key={abastecimento.codabastecimento}
                                            >
                                                <TableCell align="center">
                                                    {abastecimento.codabastecimento}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {abastecimento.nroveiculo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {formatData(abastecimento.data)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip
                                                        title="Editar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`/frotas/abastecimento/${abastecimento.codabastecimento}`}>
                                                            <EditTwoToneIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Visualizar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`/frotas/abastecimento/${abastecimento.codabastecimento}/view`}>
                                                            <VisibilityOutlinedIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Excluir"
                                                        enterDelay={50}
                                                    >
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                                            onMouseLeave={(e) => e.currentTarget.style.color = ''}
                                                            onClick={() => this.handleOpen(abastecimento.codabastecimento)}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    count={totalItems}
                    page={page}
                    onPageChange={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 50, 100, 150]}
                    labelRowsPerPage="Registros por página"
                />

                <DeleteConfirmationModal
                    open={open}
                    handleClose={() => this.handleClose()}
                    itemId={selectedId}
                    message={"Confirma exclusão do abastecimento " + selectedId + '?'}
                    handleDelete={() => this.handleDelete(selectedId)}
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div >
        );
    }
}

export default AbastecimentoList;